import React from 'react';
import PropTypes from 'prop-types';
import { IconWithTooltip } from './IconWithTooltip';

export const InfoIcon = ({ handleClick }) => (
  <IconWithTooltip
    handleClick={handleClick}
    ariaLabel="info"
    tooltip="More Info"
    icon="info-circle"
  />
);

InfoIcon.propTypes = {
// eslint-disable-next-line react/require-default-props
  handleClick: PropTypes.func,
};
